export const HEADER_VISIBILITY_TYPE_ANDROID = 'header_visibility';
export const HEADER_VISIBILITY_TYPE_IOS = 'header_VISIBILITY';
export const LOCATION_TYPE = 'adparams';
export const GET_AUTHENTICATION_TOKEN_TYPE = 'getAuthenticatonToken';
export const CLOSE_SCREEN = 'close';
export const HANDLE_WEBVIEW_BACK = 'handleWebviewBack';
export const GET_SESSION_DETAILS = 'getSessionDetails';
export const SAVE_SESSION_DETAILS = 'saveSessionDetails';
export const REFRESH_AUTHENTICATION_TOKEN = 'refreshAuthenticationToken';
